import React, { createContext, useState } from "react";

import { Agent } from "Models/agent";

import { useAppState } from "Context/StateContext";
import { ContactType, Status } from "Util/enums";
import { Contact } from "Models/contact";
import { Location } from "Models/location";
import { UseState } from "Types";

interface AgentContextProps {
  agent: Agent;
  setAgent: UseState<Agent>;
  handleUpdateAgent: (attribute: string, value: any) => void;
}

const AgentContext = createContext<AgentContextProps>({} as AgentContextProps);

interface AgentProviderProps {
  children: React.ReactChild;
}

const AgentProvider = ({ children }: AgentProviderProps) => {
  const { currentUser } = useAppState();

  const [agent, setAgent] = useState<Agent>({
    status: Status.ACTIVE,
    established: undefined,
    createdCompanyId: currentUser?.companyId,
    isUsingNetworkToken: false,
    contacts: [
      {
        id: undefined,
        name: "",
        email: "",
        phone: "",
        firstName: "",
        lastName: "",
        mobilePhone: "",
        valid: true,
        isPrimary: true,
        contactType: ContactType.PRIMARY,
        status: Status.ACTIVE,
      } as Contact,
    ],
    locations: [
      {
        id: undefined,
        name: "",
        type: "Primary",
        valid: true,
        status: Status.ACTIVE,
      } as Location,
    ],
  } as Agent);

  const handleUpdateAgent = (attribute: string, value: any) => {
    setAgent((state: any) => ({ ...state, [attribute]: Array.isArray(value) ? [...value] : value, changed: true }));
  };

  return (
    <AgentContext.Provider
      value={{
        agent,
        setAgent,
        handleUpdateAgent,
      }}
    >
      {children}
    </AgentContext.Provider>
  );
};

export { AgentContext, AgentProvider };
